import { List, Stack, Text, Title } from '@mantine/core';
import type { ReactNode } from 'react';

/** Mise en forme simple des réponses : titres « ## », puces « - », paragraphes. */
export function AiText({ text }: { text: string }) {
  const blocks: ReactNode[] = [];
  let bullets: string[] = [];
  const flush = (key: string) => {
    if (bullets.length) {
      blocks.push(
        <List key={key} size="sm" spacing={2} withPadding>
          {bullets.map((b, i) => (
            <List.Item key={i}>{b}</List.Item>
          ))}
        </List>,
      );
      bullets = [];
    }
  };
  text.split('\n').forEach((raw, i) => {
    const line = raw.trim();
    if (/^[-*•]\s+/.test(line)) {
      bullets.push(line.replace(/^[-*•]\s+/, '').replace(/\*\*/g, ''));
      return;
    }
    flush(`l${i}`);
    if (!line) return;
    if (/^#{1,4}\s+/.test(line)) {
      blocks.push(
        <Title key={i} order={6} mt={6} c="violet.8">
          {line.replace(/^#{1,4}\s+/, '')}
        </Title>,
      );
    } else {
      blocks.push(
        <Text key={i} size="sm">
          {line.replace(/\*\*/g, '')}
        </Text>,
      );
    }
  });
  flush('end');
  return <Stack gap={4}>{blocks}</Stack>;
}
